// Actiondan gelen datalar ile stateler güncellenecek
export const dealerLoading = (state, payload) => {
    state.loading = payload
}

export const listCompanyTypes = (state, payload) => {
    state.companyTypes = payload.data
}

export const listCompany = (state, payload) => {
    state.companies = payload.data ? payload.data : payload
    state.companyStatus = payload
    state.companyPageInfo = payload.list_info
}

export const companyInfo = (state, payload) => {
    state.companyId = payload.data ? payload.data : payload
}

export const companyDetail = (state, payload) => {
    state.company = payload.data ? payload.data : payload
}

export const companyStatus = (state, payload) => {
    state.companyStatus = payload
}

export const companyAddressStatus = (state, payload) => {
    state.addressStatus = payload
}

export const companyUserStatus = (state, payload) => {
    state.userStatus = payload
}

export const companyAddresses = (state, payload) => {
    state.addresses = payload.data ? payload.data : payload
}

export const companyUsers = (state, payload) => {
    state.users = payload.data
}

export const serviceFormStatus = (state, payload) => {
    state.serviceFormStatus = payload
}

export const serviceForms = (state, payload) => {
    state.serviceForms= payload.data ? payload.data : []
    state.serviceFormPageInfo = payload.list_info
}

export const serviceFormsMovements = (state, payload) => {
    state.serviceFormMovements = payload ? payload.data ? payload.data : [] : []
}

export const serviceFormMovePhotoStatus = (state, payload) => {
    state.serviceFormMovePhotoStatus = payload
}

export const serviceFormDetail = (state, payload) => {
    state.serviceFormDetail = payload.data ? payload.data : {}
}



// WEBPACK FOOTER //
// ./src/store/modules/Dealer/Mutaions.js